import React, { useEffect, useState } from 'react';
import ResultsPage from './PipsqueakWidget';

// Opened in a new tab from External Risk Scan's "Preview Full Report" button. The scan
// result never leaves the browser (no upload, no shareable link) — it's handed off via
// sessionStorage, which is scoped to this tab and cleared when the tab closes.
export const INTERNAL_REPORT_PREVIEW_KEY = 'pipsqueak_internal_report_preview';

function InternalReportPreview() {
  const [payload, setPayload] = useState(undefined); // undefined = still loading

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem(INTERNAL_REPORT_PREVIEW_KEY);
      setPayload(raw ? JSON.parse(raw) : null);
    } catch (e) {
      setPayload(null);
    }
  }, []);

  if (payload === undefined) return null;

  if (!payload || !payload.results) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center text-center p-5" style={{ minHeight: '100vh' }}>
        <h3>No report to preview</h3>
        <p className="text-muted">
          This tab has no scan data. Go back to External Risk Scan and click "Preview Full Report" again.
        </p>
      </div>
    );
  }

  return (
    <ResultsPage
      embeddedResults={payload.results}
      embeddedProvider={payload.provider || null}
      embeddedTheme={payload.theme || 'light'}
      forcedStyle="slide_deck"
      gated={false}
    />
  );
}

export default InternalReportPreview;
